import { z } from 'zod';
import type { $brand } from 'zod/v4/core';

// Brands are structural, so these are the same types the domain declares — a contract branding an
// id creates no edge to any context, and nothing of the domain reaches a browser bundle: the
// transform is a type-level cast that emits no runtime code. Practice and practice-member ids live
// here rather than in a context because almost every context's contracts name them.
//
// The transform, rather than z.brand(): z.brand() brands input as well as output, which would
// force branded values on external callers. This keeps z.input plain and z.output branded.
export type PracticeId = string & $brand<'PracticeId'>;
export const practiceIdSchema = z.uuid().transform((id) => id as PracticeId);

export type PracticeMemberId = string & $brand<'PracticeMemberId'>;
export const practiceMemberIdSchema = z.uuid().transform((id) => id as PracticeMemberId);
